<m-modal :open.sync="open"
         class="m-organize-table-columns-modal"
         size="small"
         :title="'m-organize-table-columns-modal:title' | f-m-i18n">
    <slot slot="trigger"
          name="trigger">
        <m-button>{{'m-organize-table-columns-modal:title' | f-m-i18n}}</m-button>
    </slot>
    <m-organize-table-columns :columns="internalColumns"
                              @reorganize="reorganize">
    </m-organize-table-columns>
    <template #footer>
        <m-button class="m-organize-table-columns-modal__reorganize-button"
                  @click="saveReorganize()">
            {{'m-organize-table-columns-modal:action.reorganize' | f-m-i18n}}
        </m-button>
        <m-button @click="reset()"
                  skin="secondary">
            {{'m-organize-table-columns-modal:action.reset' | f-m-i18n}}
        </m-button>
    </template>
</m-modal>
